export default "__VITE_ASSET__CE9_VO0$__"